import "./state.css";

function Stats({ itemsList }) {
  if (itemsList.length == 0) {
    return <p className="footer">You have no tasks yet!</p>;
  }

  let allItemsCount = itemsList.length;

  let finishedItems = itemsList.filter((ele) => ele.status === "Done");
  let percentage = (finishedItems.length / allItemsCount) * 100;
  // console.log(percentage);

  return (
    <footer className="footer">
      {percentage == 100
        ? "yaaaaaaaaaaaaaay💫💫💫"
        : `you ${allItemsCount} tasks on your list and you already finished
      ${finishedItems.length}
      (${percentage ? Math.trunc(percentage) : ""}%)`}
      ❤️
    </footer>
  );
}

export default Stats;
